"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var ramda_1 = require("ramda");
var Div_1 = __importDefault(require("../Div"));
var index_1 = __importDefault(require("../Text/index"));
var styles_1 = require("../../utils/styles");
var Image_1 = __importDefault(require("../Image"));
var specialDietsOrder = [
    seesignage_utils_1.SpecialDiet.lactoseFree,
    seesignage_utils_1.SpecialDiet.lowLactose,
    seesignage_utils_1.SpecialDiet.glutenFree,
    seesignage_utils_1.SpecialDiet.vegetarian,
    seesignage_utils_1.SpecialDiet.vegan,
    seesignage_utils_1.SpecialDiet.dairyFree,
    seesignage_utils_1.SpecialDiet.eggFree
];
var specialDietMappings = {
    lactoseFree: {
        label: 'L',
        stylesIndex: 0
    },
    lowLactose: { label: 'VL', stylesIndex: 1 },
    glutenFree: { label: 'G', stylesIndex: 2 },
    vegetarian: { label: 'VE', stylesIndex: 3 },
    vegan: { label: 'V', stylesIndex: 4 },
    dairyFree: { label: 'M', stylesIndex: 5 },
    eggFree: { label: 'K', stylesIndex: 6 }
};
var getSpecialDiets = function (specialDiet) {
    var specialDiets = specialDietsOrder.reduce(function (diets, diet) {
        if (specialDiet[diet]) {
            diets.push(specialDietMappings[diet]);
        }
        return diets;
    }, []);
    return specialDiets;
};
var SpecialDietComponent = function (_a) {
    var templateChildren = _a.templateChildren, specialDiet = _a.specialDiet, mediaKeys = _a.mediaKeys;
    var rootStylesObj = (0, styles_1.getObject)(templateChildren, [0, 'children', 2]);
    var specialDiets = getSpecialDiets(specialDiet);
    return (react_1.default.createElement(Div_1.default, { styles: (0, styles_1.removeNullValues)(rootStylesObj === null || rootStylesObj === void 0 ? void 0 : rootStylesObj.styles) }, specialDiets.map(function (_a) {
        var label = _a.label, stylesIndex = _a.stylesIndex;
        var stylesRoot = (0, styles_1.getObject)(rootStylesObj, ['children', stylesIndex]);
        var styles = stylesRoot === null || stylesRoot === void 0 ? void 0 : stylesRoot.styles;
        var key = stylesRoot === null || stylesRoot === void 0 ? void 0 : stylesRoot.key;
        var imagePath = (0, ramda_1.path)([key], mediaKeys);
        return (react_1.default.createElement(react_1.Fragment, { key: "".concat(label, "-text") }, key ? (react_1.default.createElement(Image_1.default, { id: 'diet-icon', alt: 'diet', src: imagePath || '', styles: (0, styles_1.removeNullValues)(styles) })) : (react_1.default.createElement(index_1.default, { id: "".concat(label, "-text"), styles: (0, styles_1.removeNullValues)(styles), value: label }))));
    })));
};
exports.default = SpecialDietComponent;
//# sourceMappingURL=SpecialDiet.js.map